export const iconFontAwesomeHumanitarianPersonPregnant = (
	<i className="fa-solid fa-person-pregnant"></i>
);
